import React from 'react';
import {connect} from 'react-redux';
import {propExistsAndNonEmpty} from '../../../../util/utils';
import {removeFilter} from '../../../../actions/selectedFilter/inResultsActions';
import {updateFilteredResults} from '../../../../actions/filteredResultActions';
import FilterItem from './filterItem/filterItem';

class FilterIndex extends React.Component {
    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(selectedFilter) {
        this.props.removeFilter(selectedFilter);

        const selectedFilters = [...this.props.selectedFilters].filter(
            filter => filter !== selectedFilter
        );

        this.props.updateFilteredResults(selectedFilters);
    }

    render() {
        const {selectedFilters, assessment} = this.props;
        const {resultsConfig} = assessment;
        const heading = (resultsConfig && resultsConfig.filterHeading) || 'Your selections';
        if (resultsConfig?.hideFilters) {
            return null;
        }
        let filters;
        if (propExistsAndNonEmpty(selectedFilters)) {
            filters = selectedFilters.map((filter, idx) => {
                return (
                    <FilterItem
                        key={idx}
                        assessmentName={assessment.internalName}
                        handleSelect={this.handleSelect}
                        handleDeselect={this.handleDeselect}
                        selectedFilters={this.props.selectedFilters}
                        filter={filter}
                        site={assessment.site}
                    />
                );
            });
        }

        return (
            <ul id="filter-display">
                <h4 className={`heading-d ${assessment.site}`}>{`${heading}:`}</h4>
                {filters}
            </ul>
        );
    }
}

const mapStateToProps = state => {
    return {
        assessment: state.app.assessment,
        selectedFilters: state.session.selectedFilters.inResults
    };
};

const mapDispatchToProps = dispatch => {
    return {
        removeFilter: filter => dispatch(removeFilter(filter)),
        updateFilteredResults: filters => dispatch(updateFilteredResults(filters))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterIndex);
